import { SwipeableDrawer } from "@mui/material";
import { useEffect, useState } from "react";
import { Cart } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import OrderDetails from "../Componants/OrderDetails";
import Sidebar from "../Componants/Sidebar";
import ViewOrder from "../Componants/ViewOrder";
import { getCurrencyRate, getStaff } from "../Redux/Action/auth.action";
import Cashier from "./Cashier";
import CustomerTable from "./CustomerTable";
import NotFound from "./NotFound";
import ProductTable from "./ProductTable";
import Transaction from "./Transaction";
import { getInstalledExtensions } from "../Redux/Action/extensions.action";
const Layout = () => {
  const dispatch = useDispatch();
  const { authUser } = useSelector((state) => state?.authReducer);
  const [isOpenOrderDetail, setIsOpenOrderDetail] = useState(true);
  const handleCloseOrderDetail = () => {
    setIsOpenOrderDetail(false);
  };
  const token = localStorage.getItem("token");
  const location = localStorage.getItem("location");
  const navigate = useNavigate();
  const sideModal = window?.location?.pathname === "/transaction" || window?.location?.pathname === "/cashier";

  useEffect(() => {
    if (token) {
      dispatch(getStaff(authUser?._id));
      dispatch(getCurrencyRate());
      dispatch(getInstalledExtensions());
    }
  }, []);
  useEffect(() => {
    if (!token || !authUser?.pos_location) {
      navigate("/");
    }
  }, [navigate, authUser, token]);
  const locationForOrder = useLocation();

  const [orderData, setOrderData] = useState({
    isShow: false,
    order: null,
  });

  const handleGetOrderData = (value, data) => {
    setOrderData({
      isShow: value,
      order: data,
    });
  };
  return (
    <>
      {location && (
        <div className="w-screen h-screen overflow-hidden">
          <div className="flex items-start">
            {token && (
              <div className="sidebar bg-sidebar p-5 h-screen overflow-y-auto">
                <Sidebar />
              </div>
            )}
            <div className="main w-full p-5 bg-secondary h-screen overflow-auto">
              <Routes>
                <Route path="/cashier" element={<Cashier />} />
                <Route path="/transaction" element={<Transaction handleGetOrderData={handleGetOrderData} />} />
                <Route path="/products" element={<ProductTable />} />
                <Route path="/customers" element={<CustomerTable />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            {sideModal && <div className="lg:block hidden min-w-[400px] max-w-[400px] h-screen overflow-auto">{locationForOrder?.pathname === "/transaction" ? <ViewOrder orderData={orderData} /> : <OrderDetails handleCloseOrderDetail={handleCloseOrderDetail} />}</div>}
            {isOpenOrderDetail && (
              <SwipeableDrawer anchor={"right"} open={isOpenOrderDetail} onClose={() => handleCloseOrderDetail()} className="block lg:hidden">
                {locationForOrder?.pathname === "/transaction" ? <ViewOrder orderData={orderData} /> : <OrderDetails handleCloseOrderDetail={handleCloseOrderDetail} />}
              </SwipeableDrawer>
            )}
            {!isOpenOrderDetail && (
              <button onClick={() => setIsOpenOrderDetail(true)} className="block lg:hidden fixed-btn">
                <Cart className="w-6 h-6" />
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Layout;
